<template>
  <AsyncPage
    :loader="useRepairLoader"
    :page-component="Repair"
  />
</template>

<script setup lang="ts">
import { defineAsyncComponent } from "vue";
import { useRepairLoader } from "./Repair.loader.ts";
import { AsyncPage } from "@saflib/vue/components";
const Repair = defineAsyncComponent(
  () => import("./Repair.vue"),
);
</script>
